import React from "react";
import { Modal, Button, Icon } from "antd";
import PropTypes from "prop-types";
import { formatDateStr, formatNumber } from "../utils/formatters";

/**
 * WalletDetailModal - Modal showing wallet details from activity log snapshot
 */
const WalletDetailModal = ({
  visible,
  walletData,
  onCancel,
}) => {
  if (!walletData) return null;

  const creditUsed =
    walletData.credit_purchased !== undefined &&
    walletData.credit_available !== undefined
      ? walletData.credit_purchased - walletData.credit_available
      : null;

  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Icon type="wallet" style={{ color: "#1890ff" }} />
          <span>Wallet #{walletData.id}</span>
        </div>
      }
      visible={visible}
      onCancel={onCancel}
      footer={<Button onClick={onCancel}>Close</Button>}
      width={500}
      maskClosable={false}
    >
      <div className="wallet-detail-grid">
        <div className="wallet-detail-row">
          <span className="wallet-detail-label">Package</span>
          <span className="wallet-detail-value">
            {walletData.package_name || "-"}
          </span>
        </div>
        <div className="wallet-detail-row">
          <span className="wallet-detail-label">Type</span>
          <span
            className="wallet-detail-value"
            style={{ textTransform: "uppercase" }}
          >
            {walletData.type || "-"}
          </span>
        </div>
        <div className="wallet-detail-row">
          <span className="wallet-detail-label">Country</span>
          <span className="wallet-detail-value">
            {walletData.country || "-"}
          </span>
        </div>
        <div className="wallet-detail-row">
          <span className="wallet-detail-label">Credit Available</span>
          <span className="wallet-detail-value">
            {formatNumber(walletData.credit_available)}
          </span>
        </div>
        <div className="wallet-detail-row">
          <span className="wallet-detail-label">Credit Purchased</span>
          <span className="wallet-detail-value">
            {formatNumber(walletData.credit_purchased)}
          </span>
        </div>
        <div className="wallet-detail-row">
          <span className="wallet-detail-label">Credit Used</span>
          <span className="wallet-detail-value">
            {creditUsed !== null ? formatNumber(creditUsed) : "-"}
          </span>
        </div>
        <div className="wallet-detail-row">
          <span className="wallet-detail-label">Status</span>
          <span className="wallet-detail-value">
            {walletData.status === "active" || walletData.status === 1 ? (
              <span style={{ color: "#52c41a" }}>Active</span>
            ) : (
              <span style={{ color: "#8c8c8c" }}>
                {walletData.status || "Inactive"}
              </span>
            )}
          </span>
        </div>
        <div className="wallet-detail-row">
          <span className="wallet-detail-label">Expire Date</span>
          <span className="wallet-detail-value">
            {walletData.expire_date
              ? formatDateStr(
                  walletData.expire_date.Time || walletData.expire_date
                )
              : "-"}
          </span>
        </div>
      </div>
    </Modal>
  );
};

WalletDetailModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  walletData: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
};

WalletDetailModal.defaultProps = {
  walletData: null,
};

export default WalletDetailModal;



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/components/MemberCreditWallet/modals/WalletDetailModal.js